import Model from './model'

export default class VehicleTrim extends Model {
    /**
     *
     * @returns {string}
     */
    resource() {
        return 'web-api/vehicle-trim'
    }
}
